(function () {
  function init(root) {
    if (!root || root.dataset.homeInitialized === 'true') return;
    root.dataset.homeInitialized = 'true';

      const revealTargets = [
        '.home-menoplay-copy > *',
        '.home-menoplay-stage',
        '.home-menoplay-proof-grid li'
      ];
      const revealItems = revealTargets.flatMap((selector) => Array.from(root.querySelectorAll(selector)));
      revealItems.forEach((item, index) => {
        item.classList.add('home-reveal-item');
        if (item.matches('.home-menoplay-stage, .home-menotest-visual, .home-doctor-visual, .home-cycle-panel, .home-final-cta')) {
          item.classList.add('home-reveal-scale');
        }
        item.style.setProperty('--home-reveal-delay', `${Math.min(index % 8, 6) * 70}ms`);
      });
      const sectionRevealItems = Array.from(root.querySelectorAll('.home-section-reveal'));

      if ('IntersectionObserver' in window) {
        const revealObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => { if (entry.isIntersecting) entry.target.classList.add('home-is-visible'); });
        }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
        const sectionRevealObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('home-is-visible');
              sectionRevealObserver.unobserve(entry.target);
            }
          });
        }, { threshold: 0, rootMargin: '0px 0px -12% 0px' });
        root.classList.add('home-reveal-motion-ready');
        window.setTimeout(() => {
          revealItems.forEach((item) => revealObserver.observe(item));
          sectionRevealItems.forEach((item) => sectionRevealObserver.observe(item));
        }, 120);
      } else {
        revealItems.forEach((item) => item.classList.add('home-is-visible'));
        sectionRevealItems.forEach((item) => item.classList.add('home-is-visible'));
      }
  }
  const currentScript = document.currentScript;
  const section = currentScript?.closest('.shopify-section');
  init(section?.querySelector('[data-home-authoritative]'));
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target?.querySelector?.('[data-home-authoritative]'));
  });
}());
